'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _assign = require('babel-runtime/core-js/object/assign');

var _assign2 = _interopRequireDefault(_assign);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _axios = require('axios');

var _axios2 = _interopRequireDefault(_axios);

var _lodash = require('lodash');

var _lodash2 = _interopRequireDefault(_lodash);

var _BaseComponent2 = require('../base/BaseComponent');

var _BaseComponent3 = _interopRequireDefault(_BaseComponent2);

var _UtilApi = require('../utils/UtilApi');

var _UtilLodash = require('../utils/UtilLodash');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var BaseCombobox = function (_BaseComponent) {
    (0, _inherits3.default)(BaseCombobox, _BaseComponent);

    function BaseCombobox() {
        var _ref;

        var _temp, _this, _ret;

        (0, _classCallCheck3.default)(this, BaseCombobox);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = BaseCombobox.__proto__ || (0, _getPrototypeOf2.default)(BaseCombobox)).call.apply(_ref, [this].concat(args))), _this), _this.handleBlur = function () {
            return _this.props.onBlur && _this.props.onBlur(true);
        }, _this.convertOptionsDualList = function (options, valueKey, labelKey) {
            _lodash2.default.each(options, function (option) {
                if (_lodash2.default.get(option, valueKey) !== undefined) {
                    option.value = _lodash2.default.get(option, valueKey);
                }
                option.label = _lodash2.default.get(option, labelKey);
                option.value = option.value.toString();

                if (_lodash2.default.get(option, 'options')) {
                    _this.convertOptionsDualList(_lodash2.default.get(option, 'options'), valueKey, labelKey);
                }
            });

            return options;
        }, _this.onInputChange = function (text) {
            var onInputChange = _this.props.onInputChange;

            onInputChange && onInputChange(text);
            if (text) {
                _this.Placeholder && _this.Placeholder.hidden();
            } else {
                _this.Placeholder && _this.Placeholder.show();
            }
            return text;
        }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
    }

    (0, _createClass3.default)(BaseCombobox, [{
        key: 'componentWillReceiveProps',
        value: function componentWillReceiveProps(nextProps) {
            var _this2 = this;

            var options = nextProps.options,
                value = nextProps.value;


            var nextProxy = (0, _UtilApi.getProxy)(nextProps);
            var proxy = (0, _UtilApi.getProxy)(this.props);
            var val = this.convertValue(value);
            var diffValue = false;
            var diffUrl = false;
            var diffOptions = false;

            if (!_lodash2.default.isEqual(nextProxy, proxy)) {
                diffUrl = true;
            }

            if (!(0, _UtilLodash.checkIsEmpty)(val) || !(0, _UtilLodash.checkIsEmpty)(this.props.value)) {
                if (_lodash2.default.isObject(val)) {
                    if (!_lodash2.default.isEqual(val, this.props.value)) {
                        diffValue = true;
                    }
                }
            }

            if (this.compareOptions(options, this.props.options)) {
                diffOptions = true;
            }

            if (this.compareValue(nextProps.value)) {
                diffValue = true;
            }

            if (diffUrl) {
                this.loadData(nextProxy, function (options) {
                    _this2.setState({
                        options: options,
                        value: diffValue ? val : _this2.props.value
                    });
                });
            } else if (diffOptions) {
                this.setState({
                    options: this.convertData(options),
                    value: diffValue ? val : this.props.value
                });
            } else if (diffValue) {
                this.setState({
                    value: val
                });
            }
        }
    }, {
        key: 'loadData',
        value: function loadData(proxy, callback) {
            var _this3 = this;

            var isTreeData = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
            var _props = this.props,
                method = _props.method,
                params = _props.params,
                headers = _props.headers;

            var config = {};
            if (_lodash2.default.isString(proxy)) {
                (0, _UtilApi.setConfigAxios)(config, { url: proxy, method: method, params: params, headers: headers });
            } else {
                (0, _UtilApi.setConfigAxios)(config, proxy);
            }

            (0, _axios2.default)(config).then(function (res) {
                if (res.status === 200) {
                    var options = [];
                    if (_lodash2.default.isFunction(proxy.loadCallback)) {
                        options = proxy.loadCallback(res);
                    } else {
                        options = _lodash2.default.get((0, _UtilApi.getRootProperty)(_this3.props), []);
                    }
                    options = _this3.convertData(options, isTreeData);
                    callback && callback(options);
                }
            }).catch(function () {});
        }
    }, {
        key: 'convertValue',
        value: function convertValue(value) {
            if (value == undefined || value == null) {
                return undefined;
            }
            if (this.props.isMulti) {
                if (_lodash2.default.isArray(value)) {
                    var result = _lodash2.default.map(value, function (item) {
                        if (_lodash2.default.isObject(item)) {
                            return item.value;
                        }
                        return item;
                    });
                    if (_lodash2.default.isEmpty(result)) {
                        return null;
                    }
                    return result;
                }
                return value;
            } else if (_lodash2.default.isObject(value)) {
                return _lodash2.default.get(value, 'value');
            }
            return value;
        }
    }, {
        key: 'convertData',
        value: function convertData(data) {
            var isTreeData = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
            var _props2 = this.props,
                valueKey = _props2.valueKey,
                labelKey = _props2.labelKey,
                colorKey = _props2.colorKey;

            if (!valueKey && !labelKey || valueKey === 'value' && labelKey === 'label') {
                return data;
            }

            if (isTreeData) {
                this.convertOptionsDualList(data, valueKey, labelKey);
                return data;
            }

            return _lodash2.default.map(data, function (item) {
                return (0, _assign2.default)(item, {
                    label: item[labelKey],
                    value: item[valueKey],
                    color: item[colorKey],
                    isFixed: item.isFixed
                });
            });
        }
    }, {
        key: 'setData',
        value: function setData(options, value) {
            if (value !== undefined) {
                this.setState({ options: this.convertData(options), value: value });
            } else {
                this.setState({ options: this.convertData(options) });
            }
        }
    }, {
        key: 'render',
        value: function render() {
            return _react2.default.createElement('div', null);
        }
    }]);
    return BaseCombobox;
}(_BaseComponent3.default);

exports.default = BaseCombobox;


BaseCombobox.defaultProps = {
    valueKey: 'value',
    labelKey: 'label'
};